
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/text-generator",
      function () {
        return require("private-next-pages/text-generator/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/text-generator"])
      });
    }
  